import colors from "assets/theme/base/colors";

const { primary, dark } = colors;

export default {
  html: {
    scrollBehavior: "smooth",
  },

  "*, *::before, *::after": {
    margin: 0,
    padding: 0,
  },

  "a, a:link, a:visited": {
    textDecoration: "none !important",
  },

  "a.link, .link, a.link:link, .link:link, a.link:visited, .link:visited": {
    color: `${dark.main} !important`,
    transition: "color 200ms ease, opacity 200ms ease !important",
  },

  "a.link:hover, .link:hover, a.link:focus, .link:focus": {
    color: `${primary.main} !important`,
    opacity: 0.85,
  },
};
